import pica from "pica";
import { readFileToDataUrl } from "./file";

export function scaleImage(input: Blob): Promise<string> {
  return new Promise(async (res, rej) => {
    const dataUrl = await readFileToDataUrl(input);

    const image = new Image();
    image.onload = () => {
      const [newWidth, newHeight] = ff(
        image.height,
        image.width,
        256 / Math.max(image.width, image.height)
      );

      const canvas = document.createElement("canvas");
      canvas.width = newWidth;
      canvas.height = newHeight;

      const picaInstance = pica();
      picaInstance.resize(image, canvas).then((resized) => {
        const dataUrl = resized.toDataURL();
        res(dataUrl);
      });
    };
    image.src = dataUrl;
  });
}

function ff(
  height: number,
  width: number,
  percentage: number
): [number, number] {
  const min = Math.min(width, height);
  const result = Math.max(min * (percentage / 100), 350);
  const newHeight = (result / min) * height;
  const newWidth = (result / min) * width;
  return [newWidth, newHeight];
}
